export default {
  storageKey(state, getters, rootState) {
    return 'history-' + rootState.page.obj.id
  },
}
